import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "promotions-bg-box"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "promotions-wrapper"
};
var _hoisted_4 = {
  class: "promotions-title"
};
var _hoisted_5 = {
  class: "swiper-box"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  class: "cell-img"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  class: "cell-info"
};
var _hoisted_10 = {
  class: "cell-title"
};
var _hoisted_11 = {
  class: "cell-icon"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "cell-price-box"
};
var _hoisted_14 = {
  key: 0,
  class: "price-box"
};
var _hoisted_15 = {
  class: "price-tag"
};
var _hoisted_16 = {
  class: "price-integer"
};
var _hoisted_17 = {
  class: "price-decimal"
};
var _hoisted_18 = ["src", "onClick"];
var _hoisted_19 = /*#__PURE__*/_createElementVNode("p", {
  class: "promotions-line"
}, null, -1);
var _hoisted_20 = ["onClick"];
var _hoisted_21 = ["src"];
import { ref, watch, onMounted } from 'vue';
import { useLess } from '@/models/hooks';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Thumbs, Autoplay } from 'swiper';
import { useRoute, useRouter } from 'vue-router';
import { jumpInteractionType, addCartList, showToastText } from '@/utils/common';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { FILL_TYPE, TEXT_BOLD_TYPE, SLIDE_TYPE, CIRCULATE_TYPE, SHOW_MORE_TYPE } from '@/configs/views/landingPage.js';
import { getAsinBatch } from '@/models/api/detailPageApi';
import constants from '@/constants';
import { useI18n } from 'vue-i18n';
import { priceSplice } from '@/utils/common';
import { LandingPage } from '@/assets/marketplaces/cn/configs';
import { Common } from '@/configs';
var BESTSELLER_SWIPER_SLIDESPERVIEW = 'auto';
export default {
  __name: 'Bestseller',
  props: {
    properties: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  setup(__props) {
    var props = __props;
    useLess('views/landingPage/bestseller/Bestseller.less');
    var MARKET_PLACE_ID = constants.MARKET_PLACE_ID,
      API_MAX_ASINS_LENGTH = constants.API_MAX_ASINS_LENGTH;
    var MAXIMUM_BESTSELLER_ASINS_LENGTH = LandingPage.MAXIMUM_BESTSELLER_ASINS_LENGTH;
    var TIME_CONVERSION_UNIT = Common.TIME_CONVERSION_UNIT;
    var widgetCategoryList = ref([]);
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var router = useRouter();
    var route = useRoute();
    var modules = [Thumbs, Autoplay];
    var thumbsSwiper = ref(null);
    var activeIndex = ref(0);
    var setThumbsSwiper = swiper => {
      thumbsSwiper.value = swiper;
    };
    var onSlideChange = swiper => {
      activeIndex.value = swiper.realIndex;
    };
    var jumpDetail = swiperItem => {
      jumpInteractionType(swiperItem, router);
    };
    var onClickBuyPop = item => {
      addCartList(item.asin, item.merchantId, 1, true, () => {
        showToastText(t('modules.checkout.SUCCESS_ADD_CART'), true);
      });
    };
    var getAsinBatchList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(asinIds = [], realIndex) {
        var _yield$getAsinBatch, data, filterStockOnHand;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAsinBatch({
                ids: asinIds.join(','),
                marketplace: MARKET_PLACE_ID,
                withCache: true
              });
            case 2:
              _yield$getAsinBatch = _context.sent;
              data = _yield$getAsinBatch.data;
              filterStockOnHand = data.filter(item => {
                var _item$availability;
                return item.stockOnHand && item.selectionEligible && ((_item$availability = item.availability) === null || _item$availability === void 0 ? void 0 : _item$availability.status) !== constants.AVAILABILITY_STATUS_ENUM.OUT_OF_STOCK;
              });
              if (widgetCategoryList.value[realIndex]) {
                filterStockOnHand.forEach(item => {
                  if (widgetCategoryList.value[realIndex].length < MAXIMUM_BESTSELLER_ASINS_LENGTH) {
                    widgetCategoryList.value[realIndex].push(item);
                  }
                });
              } else {
                widgetCategoryList.value[realIndex] = filterStockOnHand;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getAsinBatchList() {
        return _ref.apply(this, arguments);
      };
    }();
    var onClickJumpToDetailPage = item => {
      router.push({
        name: 'detailPage',
        params: {
          asinId: item.asin
        }
      });
    };
    watch(() => props.properties, properties => {
      if (properties.interactionTypeInfo && properties.interactionTypeInfo.length) {
        properties.interactionTypeInfo.forEach((tabItem, realIndex) => {
          tabItem.asinIds.forEach((_, i) => {
            if (i * API_MAX_ASINS_LENGTH < tabItem.asinIds.length) {
              var asinIds = tabItem.asinIds;
              getAsinBatchList(asinIds.slice(i * API_MAX_ASINS_LENGTH, i * API_MAX_ASINS_LENGTH + API_MAX_ASINS_LENGTH), realIndex);
            }
          });
        });
      }
    }, {
      deep: true,
      immediate: true
    });
    onMounted(() => {
      var recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.landingPage.bestsellerWidget), recordParams));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "promotions-container",
        style: _normalizeStyle(`margin-bottom: ${__props.properties.bottomSpacing}px;`)
      }, [_createElementVNode("div", _hoisted_1, [_unref(FILL_TYPE)[__props.properties.fillType] === _unref(FILL_TYPE).PICURL ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.properties.fillBackgroundColor,
        alt: "",
        class: "promotions-bg-img"
      }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "solid-color",
        style: _normalizeStyle({
          background: __props.properties.fillBackgroundColor
        })
      }, null, 4))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", {
        class: "main-title",
        style: _normalizeStyle({
          fontSize: `${__props.properties.masterTextSize}px`,
          lineHeight: `${__props.properties.masterTextSize}px`,
          fontWeight: _unref(TEXT_BOLD_TYPE)[__props.properties.masterBoldType],
          color: __props.properties.masterColor
        })
      }, _toDisplayString(__props.properties.masterTitle), 5), _createElementVNode("p", {
        class: "sub-title",
        style: _normalizeStyle({
          fontSize: `${__props.properties.deputyTextSize}px`,
          lineHeight: `${__props.properties.deputyTextSize}px`,
          fontWeight: _unref(TEXT_BOLD_TYPE)[__props.properties.deputyBoldType],
          color: __props.properties.deputyColor
        })
      }, _toDisplayString(__props.properties.deputyTitle), 5)]), _createElementVNode("div", _hoisted_5, [_createVNode(_unref(Swiper), {
        class: "button-box",
        onSwiper: setThumbsSwiper,
        slidesPerView: BESTSELLER_SWIPER_SLIDESPERVIEW,
        freeMode: true,
        watchSlidesProgress: true
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.properties.interactionTypeInfo, (buttonItem, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: buttonItem,
            class: "button-style",
            style: _normalizeStyle({
              color: index === activeIndex.value ? buttonItem.textSelectColor : buttonItem.textDefaultColor,
              background: index === activeIndex.value ? buttonItem.backgroundSelectColor : buttonItem.backgroundDefaultColor
            })
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(buttonItem.classificationTitle), 1)]),
            _: 2
          }, 1032, ["style"]);
        }), 128))]),
        _: 1
      })]), _createVNode(_unref(Swiper), {
        onSlideChangeTransitionEnd: onSlideChange,
        class: "promotions-list-swiper",
        slidesPerView: BESTSELLER_SWIPER_SLIDESPERVIEW,
        thumbs: {
          swiper: thumbsSwiper.value
        },
        autoHeight: true,
        loop: _unref(CIRCULATE_TYPE)[__props.properties.circulateType] === _unref(CIRCULATE_TYPE).LOOP,
        autoplay: _unref(SLIDE_TYPE)[__props.properties.slideType] === _unref(SLIDE_TYPE).AUTOMATIC ? {
          delay: __props.properties.swipeTime * _unref(TIME_CONVERSION_UNIT),
          disableOnInteraction: true
        } : false,
        modules: modules
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.properties.interactionTypeInfo, (swiperItem, swiperIndex) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            class: "promotions-swiper-list",
            key: swiperItem
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(widgetCategoryList.value[swiperIndex], listItem => {
              var _unref$MERCHANT_BADGE, _unref$MERCHANT_BADGE2;
              return _openBlock(), _createElementBlock("div", {
                key: listItem,
                class: "list-container"
              }, [_createElementVNode("div", {
                class: "promotions-cell",
                onClick: $event => onClickJumpToDetailPage(listItem)
              }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
                src: listItem.mainImage,
                alt: ""
              }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(listItem.title), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
                class: "icon-img",
                src: (_unref$MERCHANT_BADGE = _unref(constants).MERCHANT_BADGE_MAP) === null || _unref$MERCHANT_BADGE === void 0 ? void 0 : (_unref$MERCHANT_BADGE2 = _unref$MERCHANT_BADGE[listItem.merchantId]) === null || _unref$MERCHANT_BADGE2 === void 0 ? void 0 : _unref$MERCHANT_BADGE2.badgeURL
              }, null, 8, _hoisted_12)]), _createElementVNode("div", _hoisted_13, [listItem.ourPrice ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('common.currencyUnit')), 1), _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(priceSplice)(listItem.ourPrice.amount)[0]), 1), _createElementVNode("p", _hoisted_17, " ." + _toDisplayString(_unref(priceSplice)(listItem.ourPrice.amount)[1]), 1)])) : _createCommentVNode("", true), _createElementVNode("img", {
                src: `${_unref(constants).IMAGE_URL}assets/svg/detailTags/stroke.svg`,
                alt: "",
                class: "add",
                onClick: _withModifiers($event => onClickBuyPop(listItem), ["stop"])
              }, null, 8, _hoisted_18)])])], 8, _hoisted_6), _hoisted_19]);
            }), 128)), _unref(SHOW_MORE_TYPE)[swiperItem.moreIsShow] === _unref(SHOW_MORE_TYPE).DISPLAY ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "get-more",
              onClick: $event => jumpDetail(swiperItem)
            }, [_createTextVNode(_toDisplayString(swiperItem.announcementContent), 1), _createElementVNode("img", {
              src: `${_unref(constants).IMAGE_URL}/assets/svg/icon/downArrow.svg`,
              alt: ""
            }, null, 8, _hoisted_21)], 8, _hoisted_20)) : _createCommentVNode("", true)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["thumbs", "loop", "autoplay"])])], 4);
    };
  }
};